import React, { useEffect, useState } from "react";
import AppWrapper from "../AppWrapper";
import {
  Page,
  Spinner,
  Card,
  Button,
  InlineGrid,
  BlockStack,
  Text,
} from "@shopify/polaris";
import { useParams, useNavigate } from "react-router-dom";
import supabase from "../../supabase-client";
import { formatPlate } from "../../utility/funcs";
import { ViewIcon } from "@shopify/polaris-icons";

function Policy() {
  const navigate = useNavigate();
  const { policyId } = useParams();

  const [policy, setPolicy] = useState(undefined);

  useEffect(() => {
    const fetchData = async () => {
      const { data: policyData, error: policyError } = await supabase
        .from("insurance")
        .select(
          "*, car(id, vin, plate, model(name, image_url, brand(name))), provider(name)"
        )
        .eq("id", policyId)
        .single();
      setPolicy(policyData);
    };
    fetchData();
  }, [policyId]);

  const pageParams = () => {
    if (!policy) return { title: "", subtitle: "" };
    return {
      title: `Póliza ${policy.policy_no}`,
      subtitle: policy.provider.name,
    };
  };

  const carDetailComponent = () => {
    if (!policy) return;
    return (
      <Card>
        <div style={{ position: "absolute", right: "1rem", top: "1rem" }}>
          <Button
            icon={ViewIcon}
            onClick={() => navigate(`/cars/${policy.car.id}`)}
          />
        </div>

        <InlineGrid columns={2} alignItems="center" gap={300}>
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "right",
            }}
          >
            <img
              alt={policy.car.model.name}
              src={policy.car.model.image_url}
              style={{
                width: "200px",
                height: "200px",
                alignSelf: "center",
              }}
            />
          </div>
          <BlockStack align="center">
            <Text variant="headingMd" tone="subdued">
              {policy.car.vin}
            </Text>
            <Text variant="headingLg">{formatPlate(policy.car.plate)}</Text>
            <Text variant="headingMd" tone="subdued">
              {policy.car.model.brand.name} | {policy.car.model.name}
            </Text>
          </BlockStack>
        </InlineGrid>
      </Card>
    );
  };

  const insurerDetailComponent = () => {
    if (!policy) return;
    return (
      <Card>
        <Text variant="headingMd">Aseguradora</Text>
        <Text>{policy.provider.name}</Text>
      </Card>
    );
  };

  const pageContent = () => {
    if (!policy) return <Spinner size="small" />;
    return (
      <BlockStack gap={300}>
        <InlineGrid columns={["twoThirds", "oneThird"]} gap={300}>
          {carDetailComponent()}
          {insurerDetailComponent()}
        </InlineGrid>
      </BlockStack>
    );
  };

  return (
    <AppWrapper>
      <Page title={pageParams().title} subtitle={pageParams().subtitle}>
        {pageContent()}
      </Page>
    </AppWrapper>
  );
}

export default Policy;
